import React from 'react';
import './AboutRedesign.css';

import officeLayout from '../../../images/officeLayout.png';
import templateOneDark from '../../../images/marketing/Template1-dark.png';
import templateTwoDark from '../../../images/marketing/Template2-dark.png';
import templateThreeDark from '../../../images/marketing/Template3-dark.png';

const principles = [
  {
    title: 'Simple by design',
    description: 'The editor is built so you can click, edit, and publish without digging through complex panels.',
  },
  {
    title: 'Built for momentum',
    description: 'From domain setup to launch, every step is focused on reducing friction and helping you ship faster.',
  },
  {
    title: 'Made for everyone',
    description: 'Whether you are launching your first site or your tenth, EditPage keeps the workflow approachable.',
  },
];

const timeline = [
  'Pick a template and personalize it in minutes.',
  'Connect your domain, email, and hosting in one place.',
  'Publish confidently and keep improving as you grow.',
];

const AboutContent = ({ history }) => {
  const startBuilding = () => {
    if (history && history.push) {
      history.push('/signup');
      return;
    }
    window.location.href = '/signup';
  };

  return (
    <div className="about-redesign">
      <section className="about-hero">
        <div className="about-wrap">
          <p className="about-eyebrow">About EditPage</p>
          <h1>Website creation made practical, fast, and human.</h1>
          <p className="about-subtitle">
            EditPage was built to remove the usual complexity from creating a website.
            We focus on clarity, speed, and tools that feel intuitive from the first click.
          </p>
          <button type="button" onClick={startBuilding}>Start Building</button>
        </div>
      </section>

      <section className="about-story">
        <div className="about-wrap">
          <article className="about-story-card">
            <div className="about-copy">
              <h2>Why we built it</h2>
              <p>
                EditPage has developed easy-to-use tools so anyone can build and launch
                a website without learning code or wrestling with bloated builders.
              </p>
              <p>
                Our mission is straightforward: provide the easiest way to build and deploy
                a quality website on the web.
              </p>
              <p>
                We designed EditPage so people at any skill level can establish their web presence
                quickly and still have room to grow.
              </p>
            </div>
            <div className="about-media about-media-primary">
              <img src={officeLayout} alt="EditPage workspace" />
            </div>
          </article>

          <article className="about-principles">
            {principles.map((item) => (
              <div className="about-principle" key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </article>

          <article className="about-templates">
            <div className="about-templates-copy">
              <h2>From idea to launch, quickly</h2>
              <p>
                Start with a polished foundation, adapt it to your brand, and publish
                with confidence using one connected platform.
              </p>
              <ol>
                {timeline.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ol>
            </div>
            <div className="about-template-grid">
              <img src={templateOneDark} alt="Template preview one" />
              <img src={templateTwoDark} alt="Template preview two" />
              <img src={templateThreeDark} alt="Template preview three" />
            </div>
          </article>

          <section className="about-cta">
            <div>
              <h3>Ready to build your next website?</h3>
              <p>Join EditPage and launch with a simpler workflow from day one.</p>
            </div>
            <button type="button" onClick={startBuilding}>Create an Account</button>
          </section>
        </div>
      </section>
    </div>
  );
};

export default AboutContent;
